import React, { useEffect, useRef, useState } from 'react';
import { FiAlertCircle, FiDownload, FiHelpCircle, FiLayout, FiLoader, FiMenu, FiPlus, FiRefreshCw, FiSave, FiSearch } from 'react-icons/fi';
import './PlanStudioToolbar.css';

export default function PlanStudioToolbar({ status, draft, onDraft, onAction }) {
  const [busy, setBusy] = useState(''), [error, setError] = useState('');
  const mounted = useRef(true), locked = useRef(false);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const run = async action => {
    if (locked.current) return;
    locked.current = true; setBusy(action); setError('');
    try { await onAction(action); } catch (failure) { if (mounted.current) setError(failure.message); }
    finally { locked.current = false; if (mounted.current) setBusy(''); }
  };
  const disabled = !status.ready || !!busy;
  const shortcut = /Mac|iPhone|iPad/.test(navigator.platform) ? 'Cmd+K' : 'Ctrl+K';
  const saveLabel = status.status === 'Not saved' ? 'Resolve unsaved changes' : 'Save changes';
  const icon = (action, label, Icon, extra = '') => <button type="button" className={`plan-host__button ${extra}`} title={label} aria-label={label} disabled={disabled} onClick={() => run(action)}><Icon aria-hidden="true" /></button>;
  return <div className="plan-host" aria-label="Idea Builder tools">
    {icon('navigation', 'Open workspace navigation', FiMenu, 'plan-host__navigation')}
    <div className="plan-host__commands">
      <button type="button" className="plan-host__button plan-host__find" title={`Find (${shortcut})`} aria-label={`Find (${shortcut})`} aria-keyshortcuts="Meta+K Control+K" disabled={disabled} onClick={() => run('find')}><FiSearch /><span>Find</span><kbd>{shortcut}</kbd></button>
      {icon('layout', 'Layout', FiLayout)}
      {icon('guide', 'Idea Builder guide', FiHelpCircle)}
      {icon('refresh', 'Refresh shared plan', FiRefreshCw)}
      {icon('export', 'Export plan', FiDownload)}
      <button type="button" className={`plan-host__button plan-host__save${status.status === 'Not saved' ? ' is-error' : ''}`} title={status.error || saveLabel} aria-label={saveLabel} disabled={disabled} onClick={() => run('save')}>
        {status.status === 'Saving...' ? <FiLoader className="plan-host__spin" /> : <FiSave />}<span role="status">{status.status}</span>
      </button>
    </div>
    <form className="plan-host__quick-add" onSubmit={event => { event.preventDefault(); run('add'); }}>
      <input aria-label="Quick add idea" placeholder="Add idea" maxLength={180} autoComplete="off" value={draft} disabled={!status.ready} readOnly={!!busy} onChange={event => onDraft(event.target.value)} />
      <button type="submit" title="Add idea" aria-label="Add idea" disabled={disabled}>{busy === 'add' ? <FiLoader className="plan-host__spin" /> : <FiPlus />}</button>
    </form>
    {error && <div className="plan-host__error" role="alert"><FiAlertCircle />{error}</div>}
  </div>;
}
